import { CardJsonldCardDetailRead } from '@/api/generated';
import { SIZE } from 'types/utils';
import Badge, { CARD_VARIANT_COLOR_ENUM } from '.';

export const formatTextWithColor = (v: string) => {
  if (typeof v !== 'undefined') {
    if (v.includes('#')) {
      return <span className="text-primary-400">{v.replace(/#+/g, '')}</span>;
    }

    return v;
  }

  return '-';
};

const StatsToBadges = ({ stats }: { stats: CardJsonldCardDetailRead['elements'] }) =>
  stats && (
    <div className="flex gap-1 items-center">
      {stats.MAIN_COST && (
        <Badge size={SIZE.LG} variant={CARD_VARIANT_COLOR_ENUM.COST_HAND}>
          {formatTextWithColor(stats.MAIN_COST)}
        </Badge>
      )}
      {stats.RECALL_COST && (
        <Badge className="mr-1" size={SIZE.LG} variant={CARD_VARIANT_COLOR_ENUM.COST_RECALL}>
          {formatTextWithColor(stats.RECALL_COST)}
        </Badge>
      )}
      {stats.FOREST_POWER && (
        <Badge size={SIZE.MD} variant={CARD_VARIANT_COLOR_ENUM.FOREST}>
          {formatTextWithColor(stats.FOREST_POWER)}
        </Badge>
      )}
      {stats.MOUNTAIN_POWER && (
        <Badge size={SIZE.MD} variant={CARD_VARIANT_COLOR_ENUM.MOUNTAIN}>
          {formatTextWithColor(stats.MOUNTAIN_POWER)}
        </Badge>
      )}
      {stats.OCEAN_POWER && (
        <Badge size={SIZE.MD} variant={CARD_VARIANT_COLOR_ENUM.OCEAN}>
          {formatTextWithColor(stats.OCEAN_POWER)}
        </Badge>
      )}
    </div>
  );

export default StatsToBadges;
